// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38_Ed","clinicsSelect":"styles_clinicsSelect__1t66I"};